var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100c-11.047 0-20-8.953-20-20s8.953-20 20-20 20 8.953 20 20-8.953 20-20 20",
    fill: "#ffa726"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 132.422S19.078 108 48 108s40.125 24.422 40.125 24.422L88 148H8zM184 132s-11.078-24-40-24-40 24-40 24v16h80z",
    fill: "#546e7a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120 64c0 13.266-10.75 24-24 24S72 77.266 72 64s10.75-24 24-24 24 10.75 24 24m24 64s-13.547-27.781-48.266-27.781C61.031 100.219 48 128 48 128v20h96z",
    fill: "#cfd8dc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144 100c11.047 0 20-8.953 20-20s-8.953-20-20-20-20 8.953-20 20 8.953 20 20 20",
    fill: "#ffa726"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100c-11.047 0-20-8.953-20-20s8.953-20 20-20 20 8.953 20 20-8.953 20-20 20m96 0c11.047 0 20-8.953 20-20s-8.953-20-20-20-20 8.953-20 20 8.953 20 20 20",
    fill: "#ffa726"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.90b6c20b1d41a97762cfc2f2875fb35e.svg";
export { ForwardRef as ReactComponent };